import { unstable_createMuiStrictModeTheme } from "@material-ui/core";

export const metisUnitedTheme = unstable_createMuiStrictModeTheme({
  palette: {
    primary: {
      main: '#004373',
    },
  }
})